import { Directive, ElementRef, Host, Input, OnInit } from '@angular/core';

@Directive({
  selector: 'button',
})
export class CustomButtonDirective implements OnInit {
  constructor(@Host() private button: ElementRef<HTMLButtonElement>) {}
  @Input() useTimeoutChecker: boolean = true;
  util = {
    triggerClick: () => {
      if (this.useTimeoutChecker) {
        this.button.nativeElement.disabled = true;
        setTimeout(() => {
          this.button.nativeElement.disabled = false;
        }, 1000);
      }
    },
  };
  ngOnInit(): void {
    this.button.nativeElement.addEventListener('click', this.util.triggerClick);
  }
}
